import React, { Fragment } from 'react';

const SortCriteriaCompact = ({ sortCriteria }) => {
    const selectedOption = [
        ...sortCriteria.filter((sort) => sort.selected === true),
        {},
    ][0];
    return (
        <div className="sorting-list">
            <select
                value={selectedOption.value}
                className="sorting-dropdown"
                aria-label="Sort"
                onChange={(event) => (window.location = event.target.value)}
            >
                {sortCriteria &&
                    sortCriteria.map(({ text, value, selected }, index) => (
                        <option value={value} key={`sorteriaCompact-${index}`}>
                            {text}
                        </option>
                    ))}
            </select>
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.52552 0.765772C1.17654 0.411409 0.610712 0.411409 0.261734 0.765772C-0.0872444 1.12014 -0.0872445 1.6947 0.261734 2.04906L5.36811 7.23423C5.71709 7.58859 6.28291 7.58859 6.63189 7.23423L11.7383 2.04906C12.0872 1.6947 12.0872 1.12014 11.7383 0.765773C11.3893 0.41141 10.8235 0.41141 10.4745 0.765773L5.99768 5.31187L1.52552 0.765772Z" fill="#212121" />
            </svg>
        </div>
    );
};

export default SortCriteriaCompact;
